import PeriodicityPill from './PeriodicityPill';

const GroceryCard = ({
  sku,
  qty,
  onClick,
  showRatings,
  onPeriodicityChange,
  showQty = true,
}) => {
  return (
    <div className={'groceryItemContainer hr-mb-24'}>
      <div
        className={'grocery-item-component'}
        data-testid={`grocery-item-container-${sku.id}`}
      >
        <img
          data-id={sku.id}
          className={'groceryItemPackagedImg'}
          src={sku.packaged_image_url}
          alt={'packaged Food'}
          onClick={() => onClick(sku.id)}
        />
        <div className={'groceryItemNameContainer hr-align-left'}>
          <div className={'groceryItemBrandName hr-subtitle-md'}>
            {sku.brand_name}
          </div>
          <div
            data-id={sku.id}
            className={'groceryItemName hr-paragraph-bold'}
            onClick={() => onClick(sku.id)}
          >
            {sku.name}
          </div>
        </div>
        {sku.is_promo && <div className={'groceryItemQty hr-demi'}>FREE</div>}
        {!sku.is_promo && showQty && (
          <div className={'groceryItemQty hr-demi'}>x {qty}</div>
        )}
      </div>
      {window.showRatings || showRatings ? (
        <PeriodicityPill
          product={sku}
          onPeriodicityChange={onPeriodicityChange}
        />
      ) : null}
    </div>
  );
};

export default GroceryCard;
